import React from 'react';
import classNames from 'classnames';

export default function CardTableContent(props: {
  children?: React.ReactNode;
}) {
  return <div className={classNames()}>{props.children}</div>;
}
